// Custom storefront domains (e.g. juliacenterlb.com) — host detection helpers.
// Platform hosts serve the full POS/admin app; any other hostname is treated as
// a store domain and renders ONLY the public storefront.
const PLATFORM_HOSTS = ["localhost", "127.0.0.1", "0.0.0.0"];
const PLATFORM_SUFFIXES = [".emergentagent.com", ".poslebanon.co", ".emergent.host"];

export function isPlatformHost(host) {
  const h = String(host || "").toLowerCase().split(":")[0];
  if (!h) return true;
  if (PLATFORM_HOSTS.includes(h) || h === "poslebanon.co") return true;
  return PLATFORM_SUFFIXES.some((s) => h.endsWith(s));
}

// QA-only simulation: on a platform host, ?__host=some-domain.com pretends the
// page was loaded from that domain (persisted for the tab via sessionStorage).
export function effectiveHost() {
  const real = window.location.hostname.toLowerCase();
  try {
    const p = new URLSearchParams(window.location.search).get("__host");
    if (p && isPlatformHost(real)) sessionStorage.setItem("__sim_host", p.toLowerCase());
    if (p === "" && isPlatformHost(real)) sessionStorage.removeItem("__sim_host");
    const sim = sessionStorage.getItem("__sim_host");
    if (sim && isPlatformHost(real)) return sim;
  } catch { /* sessionStorage unavailable */ }
  return real;
}

export const isSimulatedHost = () => {
  try { return isPlatformHost(window.location.hostname) && !!sessionStorage.getItem("__sim_host"); } catch { return false; }
};

export const isCustomDomainActive = () => !isPlatformHost(effectiveHost());

// On a custom domain the app is served by the same deployment, so /api and
// /api/uploads work same-origin — keeps cookies working and the address bar clean.
export const shopBackendBase = () =>
  isCustomDomainActive() && !isSimulatedHost() ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
